

import React, { useContext } from 'react';
import { Context } from './Context'; // Adjust path to your Context file as needed
import styled from 'styled-components';
import {useNavigate} from 'react-router-dom';


export default function ElexdonTrainingPage() {
  const { coursesData} = useContext(Context);
const navigate = useNavigate();
  const scrollToCourses = () => {
    const section = document.getElementById('programs');
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleLearnMore = (course) => {
    localStorage.setItem('selectedCourse', JSON.stringify(course));
    window.location.href = '/trainingdetail';
  };

  return (
    <Container>
      {/* HERO SECTION */}
      <HeroSection>
        <Title>
          EDA: <span>Tech Training Programs</span>
        </Title>
        <Subtitle>
          Choose from our wide range of professional tech training tracks designed to transform beginners into industry-ready experts.
        </Subtitle>
        <CTAButton onClick={scrollToCourses}>Explore Training Programs</CTAButton>
      </HeroSection>

      {/* STATS SECTION */}
      <StatsSection>
        <StatItem>
          <h3>95%</h3>
          <p>Employment Rate</p>
        </StatItem>
        <StatItem>
          <h3>5,000+</h3>
          <p>Global Graduates</p>
        </StatItem>
        <StatItem>
          <h3>50+</h3>
          <p>Expert Instructors</p>
        </StatItem>
        <StatItem>
          <h3>4.9/5</h3>
          <p>Student Satisfaction</p>
        </StatItem>
      </StatsSection>

      {/* MAIN PROGRAMS SECTION */}
      <MainContentSection id="programs">
        <SectionHeader>
          <h2>Our Specialized Training Programs</h2>
          <p>Select a tech track to begin your journey.</p>
        </SectionHeader>

        <Grid>
          {coursesData.map((course) => (
            <Card key={course.id}>
              <CardImageContainer>
                <img src={course.image} alt={course.title} />
              </CardImageContainer>
              <CardContent>
                <CourseTitle>{course.title}</CourseTitle>
                <CourseDescription>{course.description}</CourseDescription>
              </CardContent>
              <CardFooter>
                <PriceTag>₦{Number(course.price).toLocaleString()}</PriceTag>
                <LearnMoreButton onClick={() => navigate(`/trainingdetail/${course.id}`)}>
                  Learn More
                </LearnMoreButton>
              </CardFooter>
            </Card>
          ))}
        </Grid>
      </MainContentSection>

      {/* WHY CHOOSE US SECTION */}
      <FeaturesSection id="features">
        <SectionHeader style={{ marginBottom: '60px' }}>
          <h2>Why Choose Elexdon Digital Academy?</h2>
          <p>We provide the ultimate framework for long-term career success in tech.</p>
        </SectionHeader>
        <FeaturesGrid>
          <FeatureCard>
            <div className="icon">🎯</div>
            <h3>Project-Based Curriculum</h3>
            <p>Don't just watch videos. Build a portfolio of real-world applications that impress global engineering hiring managers.</p>
          </FeatureCard>
          <FeatureCard>
            <div className="icon">🤝</div>
            <h3>1-on-1 Mentorship</h3>
            <p>Get paired with seasoned tech professionals working at top global companies for weekly guidance and code reviews.</p>
          </FeatureCard>
          <FeatureCard>
            <div className="icon">💼</div>
            <h3>Career Placement Support</h3>
            <p>Access our exclusive hiring partner network, resume tailoring sessions, and mock interview practice before graduation.</p>
          </FeatureCard>
        </FeaturesGrid>
      </FeaturesSection>

      {/* TESTIMONIALS SECTION */}
      <TestimonialsSection id="testimonials">
        <SectionHeader>
          <h2>Success Stories From Our Alumni</h2>
          <p>Hear how Elexdon changed the career trajectories of our graduates.</p>
        </SectionHeader>
        <TestimonialGrid>
          <TestimonialCard>
            <p>"The training program gave me the exact skills and confidence I needed. Within two months of graduating, I landed a remote engineering job!"</p>
            <AuthorInfo>
              <img src="https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&w=200&q=80" alt="Sarah J." />
              <div>
                <h4>Sarah Jenkins</h4>
                <span>Full-Stack Developer</span>
              </div>
            </AuthorInfo>
          </TestimonialCard>
          <TestimonialCard>
            <p>"The hands-on environment is unmatched. Access to expert guidance and direct peer collaboration accelerated my learning tenfold."</p>
            <AuthorInfo>
              <img src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=200&q=80" alt="David O." />
              <div>
                <h4>David Okoro</h4>
                <span>Data Scientist</span>
              </div>
            </AuthorInfo>
          </TestimonialCard>
        </TestimonialGrid>
      </TestimonialsSection>

      {/* FAQ SECTION */}
      <FAQSection id="faq">
        <SectionHeader>
          <h2>Frequently Asked Questions</h2>
          <p>Got questions? We've got answers.</p>
        </SectionHeader>
        <FAQItem>
          <h3>Do I need prior coding experience to join?</h3>
          <p>We offer tailored tracks for both absolute beginners and intermediate practitioners looking to upskill.</p>
        </FAQItem>
        <FAQItem>
          <h3>What do I need for website or blogging courses?</h3>
          <p>Students are required to buy their own domain name to enjoy our one-month free live hosting of their websites.</p>
        </FAQItem>
        <FAQItem>
          <h3>Are installment payment plans available?</h3>
          <p>Yes! We offer flexible split-payment options for all our training programs to make quality education accessible.</p>
        </FAQItem>
      </FAQSection>
    </Container>
  );
}

// --- STYLED COMPONENTS (Clean, Modern Light Mode Design without Header/Navbar) ---

const Container = styled.div`
  background-color: #f8fafc;
  color: #0f172a;
  font-family: 'Inter', system-ui, -apple-system, sans-serif;
  min-height: 100vh;
  overflow-x: hidden;
`;


const HeroSection = styled.header`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 100px 20px 60px 20px;
  min-height: 450px;
  
  /* Dark overlay combined with the Unsplash image */
  background-image: 
    linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), 
    url('https://images.unsplash.com/photo-1531482615713-2afd69097998?q=80&w=1600&auto=format&fit=crop');
    
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  
  border-bottom: 1px solid #e2e8f0;
  
  /* Makes sure your text color inside the hero is white/light for contrast */
  color: #ffffff; 
`;


const Badge = styled.span`
  background-color: #e0f2fe;
  color: #0284c7;
  padding: 6px 16px;
  border-radius: 20px;
  font-size: 0.85rem;
  font-weight: 600;
  margin-bottom: 20px;
  border: 1px solid #bae6fd;
`;

const Title = styled.h1`
  font-size: 3.5rem;
  max-width: 900px;
  line-height: 1.2;
  margin-bottom: 20px;
  font-weight: 800;
  color: white;

  span {
    background: linear-gradient(135deg, #0284c7, #4f46e5);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  @media(max-width: 768px) {
    font-size: 2.3rem;
  }
`;

const Subtitle = styled.p`
  font-size: 1.2rem;
  color: white;
  max-width: 650px;
  margin-bottom: 40px;
  line-height: 1.6;
`;

const CTAButton = styled.button`
  background: linear-gradient(135deg, #0ea5e9, #4f46e5);
  color: #ffffff;
  border: none;
  padding: 16px 36px;
  font-size: 1rem;
  font-weight: 700;
  border-radius: 8px;
  cursor: pointer;
  box-shadow: 0 10px 25px -5px rgba(14, 165, 233, 0.3);
  transition: transform 0.2s, box-shadow 0.2s;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 15px 30px -5px rgba(14, 165, 233, 0.5);
  }
`;

const StatsSection = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 30px;
  max-width: 1000px;
  margin: 0 auto;
  padding: 40px 20px;
  border-bottom: 1px solid #e2e8f0;
  text-align: center;
`;

const StatItem = styled.div`
  h3 {
    font-size: 2.2rem;
    color: #0284c7;
    margin-bottom: 5px;
  }
  p {
    color: #64748b;
    font-size: 0.95rem;
  }
`;

const MainContentSection = styled.section`
  max-width: 1200px;
  margin: 0 auto;
  padding: 80px 20px;
`;

const SectionHeader = styled.div`
  text-align: center;
  margin-bottom: 50px;

  h2 {
    font-size: 2.5rem;
    margin-bottom: 15px;
    font-weight: 700;
    color: #0f172a;
  }

  p {
    color: #475569;
    font-size: 1.1rem;
  }
`;

const CategorySelector = styled.div`
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-bottom: 50px;
`;

const TabButton = styled.button`
  background-color: ${(props) => (props.active ? '#0ea5e9' : '#ffffff')};
  color: ${(props) => (props.active ? '#ffffff' : '#334155')};
  border: 1px solid ${(props) => (props.active ? '#0ea5e9' : '#cbd5e1')};
  padding: 14px 32px;
  font-size: 1rem;
  font-weight: 700;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: ${(props) => (props.active ? '0 4px 14px rgba(14, 165, 233, 0.3)' : '0 2px 4px rgba(0,0,0,0.02)')};

  &:hover {
    border-color: #0ea5e9;
  }
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 30px;

  @media(max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;

const Card = styled.div`
  background: #ffffff;
  border-radius: 16px;
  overflow: hidden;
  border: 1px solid #e2e8f0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
  transition: transform 0.3s, border-color 0.3s, box-shadow 0.3s;

  &:hover {
    transform: translateY(-5px);
    border-color: #0ea5e9;
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.08);
  }
`;

const CardImageContainer = styled.div`
  position: relative;
  height: 200px;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.5s;
  }

  ${Card}:hover & img {
    transform: scale(1.05);
  }
`;

const LevelBadge = styled.span`
  position: absolute;
  top: 15px;
  right: 15px;
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(5px);
  color: #0369a1;
  padding: 5px 12px;
  border-radius: 6px;
  font-size: 0.75rem;
  font-weight: 600;
  border: 1px solid #bae6fd;
`;

const CardContent = styled.div`
  padding: 25px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex-grow: 1;
`;

const CourseMeta = styled.div`
  display: flex;
  justify-content: space-between;
  color: #64748b;
  font-size: 0.85rem;
  font-weight: 500;
`;

const CourseTitle = styled.h3`
  font-size: 1.4rem;
  margin: 0;
  color: #0f172a;
  font-weight: 700;
`;

const CourseDescription = styled.p`
  font-size: 0.95rem;
  color: #475569;
  margin: 0;
  line-height: 1.5;
`;

const CardFooter = styled.div`
  padding: 20px 25px;
  border-top: 1px solid #f1f5f9;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #f8fafc;
`;

const PriceTag = styled.span`
  font-size: 1.25rem;
  font-weight: 800;
  color: #0284c7;
`;

const LearnMoreButton = styled.button`
 background-color: #0284c7;
    color: #ffffff;
  border: 1px solid #0284c7;
  padding: 10px 20px;
  font-size: 0.9rem;
  font-weight: 600;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background-color: #0284c7;
    color: #ffffff;
  }
`;

const FeaturesSection = styled.section`
  background: #ffffff;
  padding: 100px 20px;
  border-top: 1px solid #e2e8f0;
  border-bottom: 1px solid #e2e8f0;
`;

const FeaturesGrid = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 40px;
`;

const FeatureCard = styled.div`
  background: #f8fafc;
  padding: 35px;
  border-radius: 16px;
  border: 1px solid #e2e8f0;

  div.icon {
    font-size: 2.5rem;
    margin-bottom: 20px;
  }

  h3 {
    font-size: 1.25rem;
    margin-bottom: 12px;
    color: #0f172a;
  }

  p {
    color: #475569;
    line-height: 1.6;
    font-size: 0.95rem;
    margin: 0;
  }
`;

const TestimonialsSection = styled.section`
  max-width: 1200px;
  margin: 0 auto;
  padding: 100px 20px;
`;

const TestimonialGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 30px;
`;

const TestimonialCard = styled.div`
  background: #ffffff;
  padding: 30px;
  border-radius: 16px;
  border: 1px solid #e2e8f0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 20px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.02);

  p {
    color: #334155;
    font-style: italic;
    line-height: 1.6;
    margin: 0;
  }
`;

const AuthorInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;

  img {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    object-fit: cover;
  }

  h4 {
    margin: 0;
    color: #0f172a;
    font-size: 1rem;
  }

  span {
    color: #0284c7;
    font-size: 0.85rem;
  }
`;

const FAQSection = styled.section`
  max-width: 800px;
  margin: 0 auto;
  padding: 20px 20px 100px 20px;
`;

const FAQItem = styled.div`
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 16px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.01);

  h3 {
    font-size: 1.1rem;
    margin: 0 0 10px 0;
    color: #0f172a;
  }

  p {
    margin: 0;
    color: #475569;
    line-height: 1.5;
    font-size: 0.95rem;
  }
`;

// --- REACT COMPONENT ---


